// extracted by mini-css-extract-plugin
export var box = "_1j-1";
export var checked = "_1j-2";
export var descriptionSpacer = "_1j-9";
export var disabled = "_1j-3";
export var icon = "_1j-6";
export var input = "_1j-0";
export var labelSpacer = "_1j-8";
export var medium = "_1j-5";
export var small = "_1j-4";
export var text = "_1j-7";